import { createFeatureSelector, createSelector } from "@ngrx/store";
import * as fromUserEventGroup from "./user-event-group.reducers";

export const userEventGroupState = createFeatureSelector<fromUserEventGroup.UserEventGroupState>("userEventGroup");

export const userEventGroups = createSelector(userEventGroupState, fromUserEventGroup.selectAllUsersEventGroups);

export const userEventGroupIds = createSelector(userEventGroupState, fromUserEventGroup.selectUserEventGroupIds);
